export const SP_URL = 'https://standardsprotocol.com';
export const SP_EMAIL = 'support@standardsprotocol.com';
export const SP_MAILTO = `mailto:${SP_EMAIL}?subject=${encodeURIComponent('Trade PMI enquiry: tailored solutions')}`;

export const MARKETS = [
  { code: 'ASX', name: 'ASX (Australia)', region: 'Australia' },
  { code: 'NASDAQ', name: 'NASDAQ (US)', region: 'US' },
  { code: 'NYSE', name: 'NYSE (US)', region: 'US' },
  { code: 'LSE', name: 'LSE (UK)', region: 'UK' },
  { code: 'TSE', name: 'TSE (Japan)', region: 'Japan' },
  { code: 'HKEX', name: 'HKEX (Hong Kong)', region: 'Hong Kong' },
];

const ACK_KEY = 'tpmi_ack_v1';
export const hasAcknowledged = () => localStorage.getItem(ACK_KEY) === 'true';
export const saveAcknowledgement = () => localStorage.setItem(ACK_KEY, 'true');
